/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RoomObservationState {
    Unknown = -1,
    NotObserving = 0,
    Observing = 1,
    Recording = 2,
}
